import { INFORMATION_PATH } from 'installations/navigation';

module.exports = {
  path: INFORMATION_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationInformation'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/information/index.js